import { type CSSProperties, useEffect, useMemo, useState } from 'react';
import { cn } from '~/lib/utils';
import Icon from './ui/Icon';

function Avatar({
  url,
  size = 50,
  className,
}: {
  url?: string | null;
  size?: number;
  className?: string;
}) {
  const [error, setError] = useState(false);

  const finalUrl = useMemo(() => {
    if (!url) return null;

    const isBlob = url.startsWith('blob:');
    if (isBlob) return url;

    return `${url}?width=${size}&height=${size}&aspect_ratio=1:1`;
  }, [url, size]);

  useEffect(() => {
    if (url) {
      setError(false);
    }
  }, [url]);

  return (
    <div
      className={cn(
        'size-(--avatar-size) text-[length:var(--avatar-size)] rounded-full bg-avatar-background flex items-center justify-center',
        className,
      )}
      style={{ '--avatar-size': `${size}px` } as CSSProperties}
    >
      {url && !error ? (
        <img
          className="rounded-full object-cover"
          src={finalUrl || undefined}
          alt="avatar"
          style={{ width: '100%', height: '100%' }}
          onError={() => setError(true)}
        />
      ) : (
        <Icon name="account" className="text-avatar-stroke text-[40%] leading-none" />
      )}
    </div>
  );
}

export default Avatar;
